var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRvoCircleIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon rvo-circle-icon",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "gray"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.667c2.946 0 5.333 2.387 5.333 5.333S10.946 13.333 8 13.333 2.667 10.946 2.667 8 5.054 2.667 8 2.667zM3.667 8a4.333 4.333 0 007.023 3.398L4.602 5.31A4.322 4.322 0 003.667 8zM8 3.667c-1.016 0-1.95.35-2.69.935l6.088 6.088A4.333 4.333 0 008 3.667z"
  })));
}

export default SvgRvoCircleIconSv;